import { useState } from 'react';
import getWdCar from '../../api/cars/getWdCar';
import Select from '../Select/Select';
import { PAYMENT_TYPES_OPTIONS } from '../../constants';

const PAYMENT_TYPES_PREPAYMENT_INVOICE = 4;
const PAYMENT_TYPES_PREPAYMENT_CARD = 5;
const SelectPaymentTypes = ({ handleSetSelect, handleSetState, style, dop, ...props }) => {
  return (
    <Select
      handleSetSelect={(val) => handleSetSelect && handleSetSelect(val)}
      handleSetState={handleSetState}
      options={
        dop
          ? [
              { value: PAYMENT_TYPES_PREPAYMENT_INVOICE, label: 'ÐÑÐµÐ´Ð¾Ð¿Ð»Ð°ÑÐ° (ÑÑÐµÑ Ð½Ð° Ð¾Ð¿Ð»Ð°ÑÑ)' },
              { value: PAYMENT_TYPES_PREPAYMENT_CARD, label: 'ÐÑÐµÐ´Ð¾Ð¿Ð»Ð°ÑÐ° (Ð¾Ð¿Ð»Ð°ÑÐ° ÐºÐ°ÑÑÐ¾Ð¹)' },
            ]
          : PAYMENT_TYPES_OPTIONS
      }
      placeholder={'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°'}
      style={style}
      {...props}
    />
  );
};

export default SelectPaymentTypes;
